import { FaPlus, FaTrashAlt, FaGripVertical } from 'react-icons/fa';
import { FieldShell } from './FieldShell';
import { useDomFieldId } from './_useFieldName';

const BLOCK = 'LStudio__app_field';

/*
    🔥 FILAS DINÁMICAS

    Un campo que contiene N sub-formularios: teléfonos, integrantes,
    ítems de una factura, redes sociales. El más útil de todo el pack
    en un panel de administración.

    Recibe `renderRow` y no un esquema fijo, así que sirve para
    cualquier forma de fila sin tocar este archivo.
*/

export const FieldRepeater = ({
    id, label, hint, error,
    rows = [], onChange, renderRow,
    emptyRow = {},
    addText = 'Agregar',
    minRows = 0, maxRows = 0,
    isDisabled = false, span = 2,
}) => {

    const IS_FULL = maxRows > 0 && rows.length >= maxRows;

    const onAdd = () => onChange?.([...rows, { ...emptyRow }]);

    const onRemove = (index) => onChange?.(rows.filter((_, i) => i !== index));

    const onUpdate = (index) => (key, value) => {
        const NEXT = rows.map((row, i) => (i === index ? { ...row, [key]: value } : row));
        onChange?.(NEXT);
    };

    const onMove = (index, delta) => {
        const TARGET = index + delta;
        if (TARGET < 0 || TARGET >= rows.length) return;
        const NEXT = [...rows];
        [NEXT[index], NEXT[TARGET]] = [NEXT[TARGET], NEXT[index]];
        onChange?.(NEXT);
    };

    const DOM_ID = useDomFieldId(id);

    return (
        <FieldShell id={DOM_ID} label={label} error={error} span={span} isDisabled={isDisabled}
            hint={hint ?? (maxRows ? `${rows.length}/${maxRows}` : undefined)} >

            <div className={`${BLOCK}__repeater`}>

                {
                    rows.map((row, index) => (
                        <div key={index} className={`${BLOCK}__repeater_row`}>

                            <span className={`${BLOCK}__repeater_handle`}
                                title="Reordenar con las flechas" aria-hidden="true" >
                                <FaGripVertical />
                            </span>

                            <div className={`${BLOCK}__repeater_body`}>
                                {renderRow?.({ row, index, onSet: onUpdate(index), isDisabled })}
                            </div>

                            <div className={`${BLOCK}__repeater_actions`}>

                                <button type="button" aria-label="Subir"
                                    disabled={isDisabled || index === 0}
                                    onClick={() => onMove(index, -1)} >↑</button>

                                <button type="button" aria-label="Bajar"
                                    disabled={isDisabled || index === rows.length - 1}
                                    onClick={() => onMove(index, 1)} >↓</button>

                                <button type="button" aria-label="Quitar fila" data-danger="true"
                                    disabled={isDisabled || rows.length <= minRows}
                                    onClick={() => onRemove(index)} >
                                    <FaTrashAlt />
                                </button>

                            </div>

                        </div>
                    ))
                }

                {
                    rows.length === 0 && (
                        <p className={`${BLOCK}__repeater_empty`}>Todavía no agregaste nada.</p>
                    )
                }

                <button type="button" className={`${BLOCK}__repeater_add`}
                    disabled={isDisabled || IS_FULL} onClick={onAdd} >
                    <FaPlus /> {addText}
                </button>

            </div>

        </FieldShell>
    );
};
